import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

const fmt = (n) => (n === "" || n === null || n === undefined || Number.isNaN(Number(n)) ? "" : Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

export function CurrencyInput({ value, onChange, className, ...props }) {
  const [text, setText] = useState(fmt(value));
  const [focus, setFocus] = useState(false);
  useEffect(() => { if (!focus) setText(fmt(value)); }, [value, focus]);
  return (
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground">$</span>
      <Input {...props} inputMode="decimal" className={cn("pl-7 font-mono-num", className)} value={text}
        onFocus={() => setFocus(true)}
        onChange={(e) => { const raw = e.target.value.replace(/[^0-9.]/g, ""); setText(raw); onChange(raw === "" ? 0 : Math.round(parseFloat(raw) * 100) / 100 || 0); }}
        onBlur={() => { setFocus(false); setText(fmt(value)); }} />
    </div>
  );
}
